<ng-container *ngFor="let prop of properties">
  <q-bo-property-inline [property]="prop" [type]="prop.Type"></q-bo-property-inline>
</ng-container>
